import { render, staticRenderFns } from "./UserLayout.vue?vue&type=template&id=f2065a6a&scoped=true&"
import script from "./UserLayout.vue?vue&type=script&lang=js&"
export * from "./UserLayout.vue?vue&type=script&lang=js&"
import style0 from "./UserLayout.vue?vue&type=style&index=0&id=f2065a6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2065a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2065a6a')) {
      api.createRecord('f2065a6a', component.options)
    } else {
      api.reload('f2065a6a', component.options)
    }
    module.hot.accept("./UserLayout.vue?vue&type=template&id=f2065a6a&scoped=true&", function () {
      api.rerender('f2065a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/UserLayout.vue"
export default component.exports